import { AttachmentsApi } from 'SharedDir/backend/api';

export default () => ({
  // @ts-ignore
  downloadFile: (...args: any[]) => AttachmentsApi.downloadFile(...args),
  // @ts-ignore
  removeFile: (...args: any[]) => AttachmentsApi.removeFile(...args),
  getBase64Content: (fileId) => AttachmentsApi.getBase64Content(fileId),
  getBlobContent: (fileId) => AttachmentsApi.getBlobContent(fileId),
});
